module.exports = {
    "source_code": "HLXEMS",
    "site_id": "info.nursing.duke.edu",
    "title": "Duke University School of Nursing",
    "tfn": "",
    "url": "https://info.nursing.duke.edu/",
    "gtm_code": "GTM-T73HXLPM",
}